import { UserAvatarWithPrimary } from '../UserAvatarWithPrimary/UserAvatarWithPrimary';

export const AvatarWithName = ({ name, photo, isPrimary }: { name: string; photo: string; isPrimary: boolean }) => {
  return (
    <div className="flex items-center gap-2">
      <UserAvatarWithPrimary name={name} photo={photo} isPrimary={isPrimary} />
      <div className="text-m-m">{name}</div>
    </div>
  );
};
